// ============================================================
// コマツバラ形成外科クリニック
// カート追加前パスワード認証（GAS連携版）
// ============================================================

const GAS_URL = 'https://script.google.com/macros/s/AKfycbyyr9IWC9w4putelv7MWfS2IKsi36pdEOT8Yp_q45aJ6pNrbsF-U_LtBkTkqgu0aH48/exec';
const SESSION_KEY = 'komatsubara_cart_auth';
const MAX_RETRY = 3;
const RETRY_DELAY_MS = 1500;

const DIALOG_SETTINGS = {
  shopName: 'コマツバラ形成外科クリニック',
  title: '患者様専用ショップ',
  body: 'ご購入にはパスワードが必要です'
};

function isAuthenticated() {
  const expiry = localStorage.getItem(SESSION_KEY + '_expiry');
  if (!expiry) return false;
  return Date.now() < parseInt(expiry);
}

function setAuthenticated() {
  const hours = 24;
  localStorage.setItem(SESSION_KEY + '_expiry', Date.now() + hours * 60 * 60 * 1000);
}

async function fetchWithRetry(url, options, retryCount = 0) {
  try {
    const res = await fetch(url, options);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return await res.json();
  } catch (err) {
    if (retryCount < MAX_RETRY - 1) {
      await new Promise(r => setTimeout(r, RETRY_DELAY_MS));
      return fetchWithRetry(url, options, retryCount + 1);
    }
    throw err;
  }
}

async function verifyPassword(password, onSuccess, onError) {
  try {
    const result = await fetchWithRetry(GAS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ password })
    });
    if (result.ok) {
      onSuccess();
    } else {
      onError('wrong');
    }
  } catch (e) {
    onError('network');
  }
}

function removeAllGates() {
  const style = document.getElementById('cart-gate-style');
  if (style) style.remove();
  document.querySelectorAll('#cart-gate-trigger').forEach(el => el.remove());
  document.querySelectorAll('.cart-gate-shoppay-overlay').forEach(el => el.remove());
  document.querySelectorAll('.cart-gate-sticky-overlay').forEach(el => el.remove());
}

const MAX_ATTEMPTS = 5;
const LOCKOUT_MS = 30 * 1000;

function isLockedOut() {
  const until = localStorage.getItem(SESSION_KEY + '_lockout');
  if (!until) return false;
  return Date.now() < parseInt(until);
}

function getLockoutRemaining() {
  const until = localStorage.getItem(SESSION_KEY + '_lockout');
  return Math.ceil((parseInt(until) - Date.now()) / 1000);
}

function setLockout() {
  localStorage.setItem(SESSION_KEY + '_lockout', Date.now() + LOCKOUT_MS);
  localStorage.removeItem(SESSION_KEY + '_attempts');
}

function incrementAttempts() {
  const current = parseInt(localStorage.getItem(SESSION_KEY + '_attempts') || '0');
  const next = current + 1;
  localStorage.setItem(SESSION_KEY + '_attempts', next);
  return next;
}

function resetAttempts() {
  localStorage.removeItem(SESSION_KEY + '_attempts');
}

(function addSpinnerStyle() {
  const s = document.createElement('style');
  s.textContent = '@keyframes cart-gate-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(s);
})();

const EYE_OPEN = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>`;
const EYE_CLOSED = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>`;

function showPasswordModal(onSuccess) {
  if (isLockedOut()) {
    const sec = getLockoutRemaining();
    alert(`パスワードを${MAX_ATTEMPTS}回間違えました。${sec}秒後に再度お試しください。`);
    return;
  }

  const existing = document.getElementById('cart-gate-modal');
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = 'cart-gate-modal';
  modal.innerHTML = `
    <div style="
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0,0,0,0.5); z-index: 99999;
      display: flex; align-items: center; justify-content: center;
    ">
      <div style="
        background: #fff; padding: 40px; border-radius: 8px;
        max-width: 400px; width: 90%; text-align: center;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
      ">
        <p style="margin-bottom: 8px; font-size: 13px; color: #888;">
          ${DIALOG_SETTINGS.shopName}
        </p>
        <h2 style="margin-bottom: 24px; font-size: 18px; color: #333;">
          ${DIALOG_SETTINGS.title}
        </h2>
        <p style="margin-bottom: 20px; font-size: 14px; color: #555;">
          ${DIALOG_SETTINGS.body}
        </p>
        <div style="position: relative; margin-bottom: 12px;">
          <input
            id="cart-gate-input"
            type="password"
            placeholder="パスワードを入力"
            style="
              width: 100%; padding: 12px; padding-right: 44px; font-size: 14px;
              border: 1px solid #ddd; border-radius: 4px;
              box-sizing: border-box;
            "
          />
          <button id="cart-gate-toggle" type="button" style="
            position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
            background: none; border: none; cursor: pointer; padding: 0;
            color: #aaa; display: flex; align-items: center; justify-content: center;
          ">${EYE_OPEN}</button>
        </div>
        <p id="cart-gate-error" style="
          color: red; font-size: 13px; margin-bottom: 12px; display: none;
        ">パスワードが違います</p>
        <p id="cart-gate-network-error" style="
          color: #e67e00; font-size: 13px; margin-bottom: 12px; display: none;
        ">通信エラーが発生しました。しばらく待ってから再度お試しください。</p>
        <button id="cart-gate-submit" style="
          width: 100%; padding: 12px; background: #333; color: #fff;
          border: none; border-radius: 4px; font-size: 14px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
        ">確認する</button>
        <button id="cart-gate-cancel" style="
          width: 100%; padding: 12px; background: transparent; color: #888;
          border: none; font-size: 13px; cursor: pointer; margin-top: 8px;
        ">キャンセル</button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  const submitBtn = document.getElementById('cart-gate-submit');
  const input = document.getElementById('cart-gate-input');

  document.getElementById('cart-gate-toggle').addEventListener('click', () => {
    const toggle = document.getElementById('cart-gate-toggle');
    if (input.type === 'password') {
      input.type = 'text';
      toggle.innerHTML = EYE_CLOSED;
    } else {
      input.type = 'password';
      toggle.innerHTML = EYE_OPEN;
    }
  });

  function handleSubmit() {
    const password = input.value;
    if (!password) return;

    submitBtn.disabled = true;
    submitBtn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        style="animation: cart-gate-spin 0.8s linear infinite; vertical-align: middle; margin-right: 6px;">
        <circle cx="12" cy="12" r="10" stroke-opacity="0.25"/>
        <path d="M12 2a10 10 0 0 1 10 10"/>
      </svg>確認中
    `;
    document.getElementById('cart-gate-error').style.display = 'none';
    document.getElementById('cart-gate-network-error').style.display = 'none';

    verifyPassword(
      password,
      () => {
        resetAttempts();
        setAuthenticated();
        // 価格ゲート（komatsubara-price-gate.js）へ認証成功を通知する
        document.dispatchEvent(new CustomEvent('komatsubara:authenticated'));
        modal.remove();
        onSuccess();
      },
      (type) => {
        submitBtn.disabled = false;
        submitBtn.textContent = '確認する';
        input.value = '';
        input.focus();
        if (type === 'wrong') {
          const attempts = incrementAttempts();
          if (attempts >= MAX_ATTEMPTS) {
            setLockout();
            modal.remove();
            alert(`パスワードを${MAX_ATTEMPTS}回間違えました。30秒後に再度お試しください。`);
          } else {
            document.getElementById('cart-gate-error').style.display = 'block';
          }
        } else {
          document.getElementById('cart-gate-network-error').style.display = 'block';
        }
      }
    );
  }

  submitBtn.addEventListener('click', handleSubmit);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') handleSubmit();
  });
  document.getElementById('cart-gate-cancel').addEventListener('click', () => {
    modal.remove();
  });

  setTimeout(() => input.focus(), 100);
}

function disableAddToCartButton() {
  if (document.getElementById('cart-gate-style')) return;
  const el = document.createElement('style');
  el.id = 'cart-gate-style';
  el.textContent = `
    add-to-cart-component { pointer-events: none !important; }
    #cart-gate-trigger {
      pointer-events: all !important;
      position: absolute; top: 0; left: 0;
      width: 100%; height: 100%;
      z-index: 9999; cursor: pointer; background: transparent;
    }
  `;
  document.head.appendChild(el);
}

function addCartTriggerOverlay() {
  document.querySelectorAll('add-to-cart-component').forEach(component => {
    // 親要素にオーバーレイを貼る
    const parent = component.parentElement;
    if (!parent || parent.querySelector('#cart-gate-trigger')) return;
    
    parent.style.position = 'relative';
    const trigger = document.createElement('div');
    trigger.id = 'cart-gate-trigger';
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      showPasswordModal(() => {
        removeAllGates();
        const btn = component.querySelector('button[name="add"]');
        if (btn) btn.click();
      });
    });
    parent.appendChild(trigger);
  });
}

function addShopPayOverlay() {
  document.querySelectorAll('.accelerated-checkout-block').forEach(target => {
    if (target.querySelector('.cart-gate-shoppay-overlay')) return;
    const overlay = document.createElement('div');
    overlay.className = 'cart-gate-shoppay-overlay';
    overlay.style.cssText = `
      position: absolute; top: 0; left: 0;
      width: 100%; height: 100%;
      z-index: 9999; cursor: pointer; background: transparent;
    `;
    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      showPasswordModal(() => {
        removeAllGates();
        const buyNowBtn = /** @type {HTMLButtonElement | null} */ (target.querySelector('.komatsubara-buy-now-btn'));
        if (buyNowBtn) buyNowBtn.click();
      });
    });
    target.style.position = 'relative';
    target.appendChild(overlay);
  });
}

// スティッキー（追従）カートバーは独自の web component で、
// クリックすると内部で本来の「カートに追加」ボタンを .click() で発火させる。
// pointer-events:none はプログラム的な .click() を防げないため、
// バー全体に透明オーバーレイを重ねて実クリックを横取りし、認証を挟む。
function addStickyOverlay() {
  document.querySelectorAll('sticky-add-to-cart').forEach(component => {
    const bar = /** @type {HTMLElement | null} */ (component.querySelector('.sticky-add-to-cart__bar'));
    if (!bar || bar.querySelector('.cart-gate-sticky-overlay')) return;

    bar.style.position = 'relative';
    const overlay = document.createElement('div');
    overlay.className = 'cart-gate-sticky-overlay';
    overlay.style.cssText = `
      position: absolute; top: 0; left: 0;
      width: 100%; height: 100%;
      z-index: 9999; cursor: pointer; background: transparent;
    `;
    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      showPasswordModal(() => {
        removeAllGates();
        const btn = /** @type {HTMLButtonElement | null} */ (bar.querySelector('.sticky-add-to-cart__button'));
        if (btn) btn.click();
      });
    });
    bar.appendChild(overlay);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (isAuthenticated()) return;

  disableAddToCartButton();
  addCartTriggerOverlay();
  addShopPayOverlay();
  addStickyOverlay();

  const observer = new MutationObserver(() => {
    if (isAuthenticated()) return;
    addCartTriggerOverlay();
    addShopPayOverlay();
    addStickyOverlay();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// ------------------------------------------------------------
// 価格ゲート連携
// 認証が通ったら（価格ゲート側から認証した場合も含めて）
// カートまわりのロックを解除する。
// ------------------------------------------------------------
document.addEventListener('komatsubara:authenticated', () => {
  removeAllGates();
});

// komatsubara-price-gate.js から認証状態とパスワードモーダルを再利用するための入口
window.KomatsubaraGate = {
  isAuthenticated,
  showPasswordModal,
  removeAllGates,
  sessionKey: SESSION_KEY,
};
